import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { formatPKR } from '../api';
import { ownerSlug, OWNER_AVATARS } from '../utils/constants';

export default function OwnerCard({ owner }) {
  const navigate = useNavigate();
  const totalEarnings = owner.shareAmount ?? owner.totalEarned ?? 0;
  const totalWithdrawn = owner.totalWithdrawn ?? 0;
  const available = totalEarnings - totalWithdrawn;
  const initials = OWNER_AVATARS[owner.name] || owner.name.slice(0, 2).toUpperCase();

  return (
    <motion.button
      type="button"
      onClick={() => navigate(`/owners/${ownerSlug(owner.name)}`)}
      className="glass-card text-left w-full group"
      whileHover={{ scale: 1.02, y: -4 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
    >
      <div className="flex items-center gap-4 mb-4">
        <div className="w-14 h-14 rounded-full bg-wood-gradient flex items-center justify-center text-lumora-white font-serif text-lg shadow-glow">
          {initials}
        </div>
        <div>
          <h3 className="font-serif font-medium text-lumora-dark-wood">{owner.name}</h3>
          <p className="text-xs text-lumora-text/50">Owner · {owner.sharePercent}% share</p>
        </div>
      </div>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-lumora-text/60">Investment</span>
          <span className="font-medium text-lumora-wood">{formatPKR(owner.investmentAmount ?? 0)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-lumora-text/60">Available Balance</span>
          <span className="font-semibold text-lumora-wood">{formatPKR(available)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-lumora-text/60">Total Earnings</span>
          <span>{formatPKR(totalEarnings)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-lumora-text/60">Total Withdrawn</span>
          <span>{formatPKR(totalWithdrawn)}</span>
        </div>
      </div>
      <p className="text-xs text-lumora-wood/60 mt-4 opacity-0 group-hover:opacity-100 transition-opacity">
        Open financial dashboard →
      </p>
    </motion.button>
  );
}
